function buildPendingGoodsPoolColumns(columns = [], isGrouping = false) {
  return columns.map((column) => {
    if (column.field !== 'remainCtnQty') return { ...column }

    return {
      ...column,
      fixed: isGrouping ? undefined : column.fixed,
      width: isGrouping
        ? Number(column.width || column.minWidth || 100)
        : column.width,
      minWidth: column.minWidth,
      treeNode: false,
      slots: { default: 'remainCtnQty' },
    }
  })
}

function getPendingGoodsPoolGroupSpan({ row, column, columns = [] }) {
  if (!row || !row._isGroup) return null
  if (column.type === 'seq') return null
  if (column.type === 'checkbox') return null
  if (column.fixed === 'right') return null

  if (column.property === 'remainCtnQty') {
    const colspan = columns.filter(
      (item) =>
        item.type !== 'seq' &&
        item.fixed !== 'right' &&
        !item.fixed &&
        item.visible !== false
    ).length

    return { rowspan: 1, colspan: colspan || 1 }
  }

  return { rowspan: 0, colspan: 0 }
}

function getPendingGoodsPoolGroupRemainQty(rows = []) {
  return rows.reduce((sum, item) => sum + (item.remainCtnQty || 0), 0)
}

export {
  buildPendingGoodsPoolColumns,
  getPendingGoodsPoolGroupSpan,
  getPendingGoodsPoolGroupRemainQty,
}
